import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testkhi',
  templateUrl: './testkhi.component.html',
  styleUrls: ['./testkhi.component.css']
})
export class TestkhiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
